// removed by extract-text-webpack-plugin
module.exports = {"avatar":"theme__avatar___3GCeP","image":"theme__image___1H3TP","letter":"theme__letter___34Q66"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/avatar/theme.scss
// module id = 305
// module chunks = 0